import ReplayIcon from "@mui/icons-material/Replay";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { IconButton, Paper, Tooltip } from "@mui/material";
import * as React from "react";
import { useCanvasControlsStore } from "../stores/useCanvasControlsStore";

type Props = {
  zoomOnly?: boolean;
};

export const ViewControlsPanel: React.FC<Props> = ({ zoomOnly }) => {
  const { onUndo, onZoomIn, onZoomOut } = useCanvasControlsStore();

  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  return (
    <Paper
      elevation={3}
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 0.5,
        gap: 0.25,
        borderRadius: 2,
      }}
    >
      {!zoomOnly && (
        <Tooltip
          title={`Undo ${isMac ? "(⌘Z)" : "(Ctrl+Z)"}`}
          placement="right"
        >
          <span>
            <IconButton
              size="small"
              onClick={onUndo ?? undefined}
              disabled={!onUndo}
              sx={{
                borderRadius: 1,
                width: 36,
                height: 36,
              }}
            >
              <ReplayIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <Tooltip title={`Zoom In ${isMac ? "(⌘2)" : "(Ctrl+2)"}`} placement="right">
        <span>
          <IconButton
            size="small"
            onClick={onZoomIn ?? undefined}
            disabled={!onZoomIn}
            sx={{
              borderRadius: 1,
              width: 36,
              height: 36,
            }}
          >
            <ZoomInIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={`Zoom Out ${isMac ? "(⌘1)" : "(Ctrl+1)"}`} placement="right">
        <span>
          <IconButton
            size="small"
            onClick={onZoomOut ?? undefined}
            disabled={!onZoomOut}
            sx={{
              borderRadius: 1,
              width: 36,
              height: 36,
            }}
          >
            <ZoomOutIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Paper>
  );
};
